export class NavigationGroup {
    public static readonly Main = 'main';
    public static readonly SettingsDropdown = 'settings-dropdown';
}

export class BaseRoutes {
    public static Engineering = 'engineering';
}

export enum CommonNavigationPosition {
    Logout = 20000
}

export enum ManagementNavigationPosition {
    Endpoints = 10001,
    FeatureFlags = 10002,
    Logs = 10003,
    ApiTokens = 10004
}
